"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_view_component_1 = __importDefault(require("../scenario-node-view/scenario-node-view.component"));

var action_preview_styles_1 = require("./action-preview.styles");

var ActionPreview = function ActionPreview(_ref) {
  var childNode = _ref.childNode,
      actionUrl = _ref.actionUrl,
      scale = _ref.scale;
  return react_1.default.createElement(action_preview_styles_1.StyledActionPreviewWrapperDiv, {
    "data-meta": "action-preview"
  }, react_1.default.createElement(action_preview_styles_1.StyledActionPreviewTitleH2, null, react_1.default.createElement(action_preview_styles_1.StyledFontAwesomeIcon, {
    icon: 'angle-double-right'
  }), "\u30A2\u30AF\u30B7\u30E7\u30F3\u30D7\u30EC\u30D3\u30E5\u30FC"), react_1.default.createElement(action_preview_styles_1.StyledActionPreviewDiv, null, !childNode && !actionUrl ? react_1.default.createElement(action_preview_styles_1.StyledEmptyMessageP, null, "\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u5B58\u5728\u3057\u307E\u305B\u3093") : !!childNode ? react_1.default.createElement(scenario_node_view_component_1.default, {
    node: childNode,
    scale: scale
  }) : react_1.default.createElement(action_preview_styles_1.StyledActionUrlP, null, actionUrl)));
};

exports.default = ActionPreview;